//@ts-ignore
import invariant from "invariant";

/** Iran Mobile number validator return true if number is valid */
function isValidMobile(number: string): boolean {
  //@ts-ignore
  if (__DEV__) {
    invariant(
      typeof number === "string",
      `isValidMobile: param should get string but got ${typeof number}`,
    );
  }

  const format = /^((09|\+989|9)([0-9]{9}))$/;

  return format.test(number);
}

/** Email validator return true if Email is valid */
function isValidEmail(email: string): boolean {
  //@ts-ignore
  if (__DEV__) {
    invariant(
      typeof email === "string",
      `isValidEmail: param should get string but got ${typeof email}`,
    );
  }

  const format = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  return format.test(email);
}

export { isValidMobile, isValidEmail };
